import FrozenCameraIcon from 'assets/icons/CameraStream/FrozenCameraIcon';
import styles from './StreamStateNotification.module.css';

function StreamStateNotification({ isCameraActivatedInCC, streamState }) {
    let errorText = '';
    if (streamState.error)
        errorText = !isCameraActivatedInCC ? 'Camera deactivated by Control Center' : streamState.error || 'Error loading camera stream';
    else if (!streamState.isLoading && streamState.freezed) errorText = 'Frozen. Please refresh stream.';

    const showNotification = !streamState.error && streamState.info;

    return (
        <>
            {errorText && (
                <div className={styles.notification}>
                    <span className="material-symbols-outlined" style={{ color: '#4F4F4F', fontSize: '1.8rem' }}>
                        <FrozenCameraIcon />
                    </span>
                    <p>{errorText}</p>
                </div>
            )}
            {showNotification && <p className={styles['stream-state-info']}>{streamState.info}</p>}
        </>
    );
}

export default StreamStateNotification;
